<template>
    <div class="root ">
        <keep-alive>
            <router-view :pe_startWatchPosition_f="pe_startWatchPosition_f" :pe_stopWatchPosition_f="pe_stopWatchPosition_f"/>
        </keep-alive>
    </div>
</template>

<script>
    export default {
        name: "V_Ongoing_Quest_OpenMap",
        props:{
            pe_startWatchPosition_f:{
                type: Function,
                require: true
            },
            pe_stopWatchPosition_f:{
                type: Function,
                require: true
            }
        }

    }
</script>

<style scoped>


    .root{
        height: 100%;
    }


</style>